module.exports = __webpack_public_path__ + "static/media/fj.78e7816d.svg";